export default __webpack_public_path__ + "static/media/rain.d2c49a7c.svg";